import { FormControl, Theme, styled } from '@material-ui/core';

const CustomFormControl = styled(FormControl)<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  border: theme.config.defaultBorder(),
  borderRadius: theme.config.defaultBorderRadius,
  boxShadow: theme.config.defaultBoxShadow,
  alignItems: 'center',
  color: theme.palette.grey['900'],
  display: 'flex',
  flexDirection: 'row',
  fontSize: theme.typography.h3.fontSize,
  padding: theme.spacing(0.5, 1),
  '&.disabled': {
    opacity: 0.5,
  },
  width: '100%',
}));

export default CustomFormControl;
